export const Accounts_DHEU_Audit_roles = [2, 9, 11];
export const DHEU_Audit_roles = [9, 11];
export const DHEU_Accounts_roles = [2, 9];
export const Accounts_Audit_roles = [2, 11];